export const APP_RESIZE = Symbol('app/RESIZE')

export const APP_SEED = Symbol('app/SEED')

export const APP_SETUP = Symbol('app/SETUP')

export const APP_SYNC = Symbol('app/SYNC')

export const APP_UNDO = Symbol('app/UNDO')

export const POINTS_ADD = Symbol('points/ADD')

export const POINTS_CLEANUP = Symbol('points/CLEANUP')



/** WEBPACK FOOTER **
 ** ./actions.js
 **/